import React from 'react';
import Header from './header';

import { URL } from '../variables';
import { connect } from 'react-redux';
import ChangeCamModal from './changeCamModal';
import { logout } from '../actions/AppActions';
import { CandidateValidationNotice } from './CandidateUi';
import { getLanguageTexts, getSelectedLanguage } from '../language';

class NotProcesso extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }

        // this.videoRef=null;
    }

    componentDidMount(){
        this.logs_timeout=setTimeout(()=>{
            this.salvar_log();
        },30000);
    }

    componentWillUnmount(){
        clearTimeout(this.logs_timeout);
    }

    salvar_log() {
        fetch(`${URL}api/salvar_log?screen=not_processo`, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
    
            'Authorization': `Bearer ${this.props.token}`,
            // 'Content-Type': 'application/json',
          }
        }).then(async (responseLog) => {
          try {
            let resp = await responseLog.json();
            console.log(resp);
            if (resp.message == "Unauthenticated.") {
              localStorage.removeItem('token');
              // this.setState({redirect:true,path:'/'});
              this.props.logout();
            }
            else {
                this.logs_timeout=setTimeout(()=>{
                    this.salvar_log();
                },30000);
            }
          } catch (err) {
            console.log(err);
            this.logs_timeout = setTimeout(() => {
                this.salvar_log();
            }, 30000);
          }
    
        })
          .catch((err) => {
            console.log(err);
            this.logs_timeout = setTimeout(() => {
                this.salvar_log();
            }, 30000);
          });
      }


    render() {
        const t = getLanguageTexts(getSelectedLanguage());
        return (
            <div className="external-camera-card">
                <div className="external-camera-card-body">
                    <div className="external-camera-title-row">
                        <span className="candidate-auth-kicker">{t.external_camera_access}</span>
                        <h1>{this.props.faculdade.name}</h1>
                        <p>{t.candidate_name}: {this.props.user.name}</p>
                    </div>
                    {this.props.faculdade.logo != null && <div className="external-camera-logo-panel">
                        <img src={this.props.faculdade.logo} alt="Logo da instituição" />
                    </div>}
                    <CandidateValidationNotice tone="danger" title={t.notice}>
                        {t.no_process_linked}
                    </CandidateValidationNotice>
                </div>
            </div>


        );
    }


}

const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        faculdade: state.AppReducer.faculdade,
        user: state.AppReducer.user,
    }
);

export default connect(mapsStateToProps, { logout })(NotProcesso);
